import {
  formatDate
} from "@/utils/tool";

const formatTime = function(val, format) {
  return formatDate(val, format)
}

const numberFormat = function(value) {
  if (!value) return 0
  let unit = ''
  let k = 10000,
    sizes = ['', '万', '亿', '万亿'],
    i;
  if (value < k) {

  } else {
    i = Math.floor(Math.log(value) / Math.log(k));
    value = ((value / Math.pow(k, i))).toFixed(2);
    unit = sizes[i]
  }
  return value + unit
}
/* 薪资格式化 */
const changeSalary = function(val) {
  if (val) {
    if (val === '面议') {
      return val
    } else if (val.indexOf('元') > -1) {
      if (val.indexOf('以下') > -1) {
        let str1 = val.split('元')[0];
        let str = parseInt(str1) / 1000 + 'K' + val.split('元')[1]
        return str
      } else {
        let str1 = val.split('-')[0];
        let str2 = val.split('-')[1];
        let str = parseInt(str1.substring(0, str1.length - 1)) / 1000 + '-' + parseInt(str2.substring(0,
          str2.length - 1)) / 1000 + 'K'
        return str
      }
    } else if (val.indexOf('以上') > -1) {
      return val
    } else {
      let str1 = val.split('-')[0];
      let str2 = val.split('-')[1];
      let str = parseInt(str1) / 1000 + '-' + parseInt(str2) / 1000 + 'K'
      return str
    }
  }
}
/**
 * 字符串替换
 * @param val 替换的字符串
 * @param str 需要替换的字符
 * @param re 替换的字符
 */
const strReplace = function (val, str, re) {
  if (!val) return val
  let reg = new RegExp(str, 'g')
  return val.replace(reg, re)
}

export {
  formatTime,
  numberFormat,
  changeSalary,
  strReplace
}
